import React, { useState } from 'react';
import { User as UserIcon } from 'lucide-react';

interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: number;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export default function Avatar({ src, name, size = 40, onClick, style = {}, className }: AvatarProps) {
  const [errored, setErrored] = useState(false);
  const initials = (name || '')
    .split(' ')
    .map(w => w[0] || '')
    .join('')
    .toUpperCase()
    .slice(0, 2) || '';

  const commonStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: 'var(--app-surface-3)',
    color: 'var(--app-text-2)',
    fontWeight: 600,
    userSelect: 'none',
    ...style,
  };

  if (src && !errored) {
    return (
      <img
        src={src}
        alt={name || 'avatar'}
        onError={() => setErrored(true)}
        onClick={onClick}
        className={className}
        style={{ objectFit: 'cover', cursor: onClick ? 'pointer' : 'default', ...commonStyle }}
      />
    );
  }

  return (
    <div onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default', fontSize: Math.max(10, Math.round(size * 0.38)), ...commonStyle }} className={className}>
      {initials || <UserIcon size={Math.round(size * 0.55)} color="var(--lyra-color-text-muted)" />}
    </div>
  );
}
